import TechInfo from './TechInfo';

export default TechInfo;
